import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { TextField, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface TextFieldBadgeProps {
  label?: string;
  value: string[];
  onAdd: (phone: string) => void;
  onDelete: (phone: string) => void;
}

const theme = createTheme({
  components: {
    // MuiTextField: {
    //   styleOverrides: {
    //     root: {
    //       "& .MuiInputLabel-root": {
    //         color: "black",
    //         fontSize: "12px",
    //         transform: "translate(14px, 6px) scale(1)",
    //       },
    //       "& .MuiInputLabel-shrink": {
    //         transform: "translate(14px, -9.5px) scale(0.82)",
    //         color: "#3699ff",
    //       },
    //     },
    //   },
    // },
  },
});

const TextFieldBadge: React.FC<TextFieldBadgeProps> = ({
  label = "شماره تماس",
  value,
  onAdd,
  onDelete,
}) => {
  const [inputValue, setInputValue] = React.useState("");

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      !/[0-9]/.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Enter" &&
      event.key !== "ArrowLeft" &&
      event.key !== "ArrowRight"
    ) {
      event.preventDefault();
    }

    if (event.key === "Enter" && inputValue.trim() !== "") {
      onAdd(inputValue.trim());
      setInputValue("");
      event.preventDefault();
    }
  };
  const [isFocused, setIsFocused] = useState(false);
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ width: "100%" }}>
        <TextField
          className="boxInputTextFeildBadge"
          variant="outlined"
          fullWidth
          label={label}
          placeholder={
            "شماره را وارد و Enter بزنید"
            // value.length === 0 ? "شماره را وارد و Enter بزنید" : ""
          }
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onFocus={() => setIsFocused(true)}
          onBlur={() => {
            setIsFocused(false);
            if (inputValue.trim() !== "") {
              onAdd(inputValue.trim());
              setInputValue("");
            }
          }}
          InputLabelProps={{
            shrink: inputValue !== "" || value.length > 0 || isFocused,
          }}
          InputProps={{
            startAdornment: (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "nowrap",
                  overflowX: "auto",
                  gap: "8px",
                  alignItems: "center",
                  maxWidth: "100%",
                  padding: "4px ",
                  scrollbarWidth: "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                {value.map((phone, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#1D4A87",
                      borderRadius: "4px",
                      paddingLeft: "8px",
                      fontSize: "11px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span style={{ color: "#fff" }}>{phone}</span>
                    <IconButton
                      size="small"
                      onClick={() => onDelete(phone)}
                      sx={{
                        marginLeft: "1px",
                        color: "#fff !important",
                        marginBottom: "2px",
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
              </Box>
            ),
          }}
        />
      </Box>
    </ThemeProvider>
  );
};

export default TextFieldBadge;
